import type { BaseKeyFunction } from "../../../lib";

export const keyNextUp: BaseKeyFunction = () => ["nextup"];
